export default "__VITE_ASSET__DrSChbUI__"